/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Store_GetInputs */

const en_portal_store_get = /** @type {(inputs: Portal_Store_GetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get it on`)
};

const pl_portal_store_get = /** @type {(inputs: Portal_Store_GetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pobierz z`)
};

/**
* | output |
* | --- |
* | "Get it on" |
*
* @param {Portal_Store_GetInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_store_get = /** @type {((inputs?: Portal_Store_GetInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Store_GetInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_store_get(inputs)
	return en_portal_store_get(inputs)
});